import { Pipe, PipeTransform } from '@angular/core';
import { displayUserType } from 'app/core/options/user-type.opts';

@Pipe({ name: 'userType' })
export class UserTypePipe implements PipeTransform {
  transform = displayUserType
}
